import styled from 'styled-components';
import { Table } from 'antd';

const PRIMARY_BLUE = '#1890FF';

export const StyledTable = styled(Table)`
  background: white;
  border-radius: 16px;
  border: 1px solid #f0f0f0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .ant-table {
    background: white;
    border: none;
  }

  .ant-table-thead > tr > th {
    background: white !important;
    color: #262626 !important;
    border-bottom: 3px solid ${PRIMARY_BLUE} !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    height: 52px !important;
    padding: 14px 20px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;

    &:first-child { border-top-left-radius: 16px; }
    &:last-child { border-top-right-radius: 16px; }
    &::before { display: none !important; }
  }

  .ant-table-tbody > tr {
    transition: all 0.2s ease;
    border-bottom: 1px solid #f5f5f5;

    &:hover > td {
      background: #fafbff !important;
    }

    &:nth-child(even) {
      background: #fafafa;

      &:hover > td {
        background: #f0f7ff !important;
      }
    }

    &:last-child td { border-bottom: none; }
  }

  .ant-table-tbody > tr > td {
    border-bottom: none;
    padding: 18px 20px;
    font-size: 14px;
    line-height: 1.5;
    vertical-align: middle;
  }

  /* Give the first column extra breathing room from the table edge */
  .ant-table-thead > tr > th:first-child,
  .ant-table-tbody > tr > td:first-child {
    padding-left: 32px !important;
  }
  .ant-table-thead > tr > th:last-child,
  .ant-table-tbody > tr > td:last-child {
    padding-right: 32px !important;
  }

  /* Pagination styling - matches Patient Queue look */
  .ant-pagination {
    background: rgba(248, 248, 248, 0.5);
    padding: 16px 20px;
    border-radius: 8px;
    margin: 16px 0 0 !important;
  }

  .ant-pagination-total-text {
    font-weight: 500;
    color: #595959;
  }

  .ant-pagination-item:hover,
  .ant-pagination-prev:hover,
  .ant-pagination-next:hover {
    transform: translateY(-1px);
    transition: all 0.3s ease;
  }
`;

export const PaginationText = styled.span`
  font-weight: 500;
  color: #595959;
`;

export const PageContainer = styled.div`
  /* No padding here — the outer admin shell (ContentScrollArea) is the
     single source of page padding so we don't get nested insets. */
  padding: 0;
  min-height: 100%;
  box-sizing: border-box;

  @media (max-width: 640px) {
    padding: 0;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 640px) {
    margin-bottom: 16px;
    h1 { font-size: 22px; }
  }

  h1 {
    margin: 0;
    font-size: 28px;
    color: #262626;
  }

  p {
    margin: 4px 0 0;
    color: #8c8c8c;
  }
`;

export const FilterBar = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  align-items: center;

  /* On small screens make filter inputs flex to full width so they don't
     overflow horizontally and the layout collapses gracefully. */
  @media (max-width: 640px) {
    .ant-input-affix-wrapper,
    .ant-select {
      flex: 1 1 100%;
      width: 100% !important;
      min-width: 0;
    }
    > div[style*="flex: 1"] {
      display: none;
    }
  }
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;

  /* On small screens collapse to a horizontal scrolling carousel so the
     stat cards don't take up half the viewport. Uses scroll-snap so
     each card lands cleanly on swipe. */
  @media (max-width: 640px) {
    display: flex;
    grid-template-columns: none;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    margin: 0 0 16px;
    padding: 0 0 8px;
    gap: 12px;

    /* Slim styled scrollbar so users see the carousel is scrollable */
    scrollbar-width: thin;
    scrollbar-color: #d9d9d9 transparent;
    &::-webkit-scrollbar {
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #d9d9d9;
      border-radius: 3px;
    }

    > * {
      flex: 0 0 70%;
      min-width: 200px;
      max-width: 240px;
      scroll-snap-align: start;
    }
  }
`;

export const StatCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);

  .label {
    font-size: 12px;
    color: #8c8c8c;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .value {
    font-size: 28px;
    font-weight: 600;
    color: #262626;
    margin-top: 4px;
  }
`;
